import React from 'react'
import NoticeTextInput from "../../components/inputs/NoticeTextInput";
import NoticeCpvInput from "../../components/inputs/NoticeCpvInput";


function OrderObjectNotDivided(
    {
        id,
        formikProps,
    }) {

    const gId = (name) => id + "." + name;

    return (<>

        <NoticeTextInput
            formikProps={formikProps}
            id={gId("orderSubjectDescription")}
            multiline
        />

        <NoticeCpvInput
            formikProps={formikProps}
            id={gId("mainCpv")}
            required
        />

        <NoticeCpvInput
            formikProps={formikProps}
            id={gId("additionalCpv")}
            multiple
        />

    </>)
}

OrderObjectNotDivided.propTypes = {};

export default OrderObjectNotDivided;
